module.exports = __webpack_public_path__ + "static/img/home_new16.c73a43d7.jpg";